<template>
  <path pid="0" d="M21 3H5a3 3 0 00-3 3v6a11 11 0 0022 0V6a3 3 0 00-3-3zm1 9a9 9 0 01-18 0V6a1 1 0 011-1h16a1 1 0 011 1z"/><path pid="1" d="M16.29 10.29L13 13.59l-3.29-3.3a1 1 0 00-1.42 1.42l4 4a1 1 0 001.42 0l4-4a1 1 0 00-1.42-1.42z"/>
</template>
